import {PractitionerCareTeamInput, TeamContact} from "../../domain";
import {gql} from "@apollo/client";
import {useDomainErrorDialog} from "../../../../common/component/ErrorDialog";
import {useMutation$} from "../../../../graphqlsupport";
import {useCallback} from "react";
import {isoDateStringToLocalDateFormat} from "common/util/date";

type NewPractitionerCareTeamMutationInput = {
    clientProfileGuid: string;
    practitionerCareTeamInput: PractitionerCareTeamInput;
}

type NewPractitionerCareTeamResult = {
    submitPractitionerCareTeam: Partial<TeamContact>
}

const NEW_PRACTITIONER_CARE_TEAM_MUTATION = gql`
mutation (
    $clientProfileGuid: String!, 
    $practitionerCareTeamInput: PractitionerCareTeamContentInput!
) {
  submitPractitionerCareTeam(
    clientProfileGuid: $clientProfileGuid
    payload: $practitionerCareTeamInput
  ) {
    guid 
    firstName
    lastName
    startDate
    memberRole
    phone
    mobile
  }
}
`;


function reformatPractitionerCareTeamMemberInput(input: PractitionerCareTeamInput): PractitionerCareTeamInput {
    input.startDate = isoDateStringToLocalDateFormat(input.startDate);
    if (input.endDate) {
        input.endDate = isoDateStringToLocalDateFormat(input.endDate);
    }

    return input;
}

export const useSubmitNewPractitionerCareTeam$ = (
    clientProfileGuid: string,
    onSuccess: (newOffer: Partial<TeamContact>) => any,
) => {
    const {
        isRunning$,
        execute,
        data,
    } = useMutation$<NewPractitionerCareTeamMutationInput, NewPractitionerCareTeamResult>(NEW_PRACTITIONER_CARE_TEAM_MUTATION);
    const {errorMessage$, tryParsingDomainError} = useDomainErrorDialog();

    const submitPractitioner = useCallback(async (content: PractitionerCareTeamInput) => {
        try {
            const {data: result} = await execute({
                variables: {
                    clientProfileGuid,
                    practitionerCareTeamInput: reformatPractitionerCareTeamMemberInput(content),
                }
            });
            if (!!result) {
                onSuccess(result.submitPractitionerCareTeam);
            }
        } catch (e) {
            if (!tryParsingDomainError(e)) {
                throw e;
            }
        }
    }, [execute, clientProfileGuid, onSuccess, tryParsingDomainError]);

    return {
        isRunning$,
        execute: submitPractitioner,
        data,
        errorMessage$,
    };
}
